<template>
  <main
      class="page"
      role="main"
      aria-labelledby="page-title"
  >
    <header class="page-header">
      <h1
          id="page-title"
          class="h1"
      >
        Dokumentation
      </h1>
    </header>
    <div class="section-container">
      <section
          v-if="isAdmin || isTeacher || isParent"
          class="tiles"
          aria-label="Dokumentationskacheln - Dashboard / Login"
      >
        <button
            v-if="isAdmin || isTeacher"
            class="tile"
            @click="openDoc({ title: 'Dashboard', url: docDashboard })"
        >
          <div class="tile-head">
            <i class="pi pi-home nav-icon"/>
            <span class="tile-title"><strong>Dashboard</strong></span>
          </div>
        </button>
        <button
            v-if="isParent"
            class="tile"
            @click="openDoc({ title: 'Dashboard', url: docDashboardPt })"
        >
          <div class="tile-head">
            <i class="pi pi-home nav-icon"/>
            <span class="tile-title"><strong>Dashboard</strong></span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Login und Passwort', url: docLoginPasswort })"
        >
          <div class="tile-head">
            <i class="pi pi-lock nav-icon"/>
            <span class="tile-title"><strong>Login & Passwort</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Schuljahre"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Schuljahre', url: docSchuljahre })"
        >
          <div class="tile-head">
            <i class="pi pi-calendar nav-icon"/>
            <span class="tile-title"><strong>Schuljahre</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Schueler"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Schüler - Übersicht', url: docSchuelerUebersicht })"
        >
          <div class="tile-head">
            <i class="pi pi-users nav-icon"/>
            <span class="tile-title"><strong>Schüler</strong> - Übersicht</span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Schüler - Meldungen', url: docSchuelerMeldungen })"
        >
          <div class="tile-head">
            <i class="pi pi-users nav-icon"/>
            <span class="tile-title"><strong>Schüler</strong> - Meldungen</span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Schüler - Hinweise', url: docSchuelerHinweise })"
        >
          <div class="tile-head">
            <i class="pi pi-users nav-icon"/>
            <span class="tile-title"><strong>Schüler</strong> - Hinweise</span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Gruppen"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Gruppen', url: docGruppen })"
        >
          <div class="tile-head">
            <i class="pi pi-sitemap nav-icon"/>
            <span class="tile-title"><strong>Gruppen</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Angebote"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Angebote – Übersicht', url: docAngeboteUebersicht })"
        >
          <div class="tile-head">
            <i class="pi pi-clock nav-icon"/>
            <span class="tile-title"><strong>Angebote</strong> – Übersicht</span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Angebote – Automatik', url: docAngeboteAutomatik })"
        >
          <div class="tile-head">
            <i class="pi pi-clock nav-icon"/>
            <span class="tile-title"><strong>Angebote</strong> – Automatik</span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Angebote – Tagesplan', url: docAngeboteTagesplan })"
        >
          <div class="tile-head">
            <i class="pi pi-clock nav-icon"/>
            <span class="tile-title"><strong>Angebote</strong> – Tagesplan</span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Benutzer"
      >
        <button
            v-if="isAdmin"
            class="tile"
            @click="openDoc({ title: 'Benutzer', url: docBenutzer })"
        >
          <div class="tile-head">
            <i class="pi pi-user nav-icon"/>
            <span class="tile-title"><strong>Benutzer</strong></span>
          </div>
        </button>
        <button
            v-if="isTeacher"
            class="tile"
            @click="openDoc({ title: 'Benutzer', url: docBenutzerTr })"
        >
          <div class="tile-head">
            <i class="pi pi-user nav-icon"/>
            <span class="tile-title"><strong>Benutzer</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Postausgang"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Postausgang', url: docPostausgang })"
        >
          <div class="tile-head">
            <i class="pi pi-envelope nav-icon"/>
            <span class="tile-title"><strong>Postausgang</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Auswertung"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Auswertung', url: docAuswertung })"
        >
          <div class="tile-head">
            <i class="pi pi-chart-bar nav-icon"/>
            <span class="tile-title"><strong>Auswertung</strong></span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Auswertung – Lernbriefe erzeugen', url: docAuswertungLernbriefeErzeugen })"
        >
          <div class="tile-head">
            <i class="pi pi-chart-bar nav-icon"/>
            <span class="tile-title">Lernbriefe erzeugen</span>
          </div>
        </button>
        <button
            class="tile"
            @click="openDoc({ title: 'Auswertung – Lernbriefe anwenden', url: docAuswertungLernbriefeAnwenden })"
        >
          <div class="tile-head">
            <i class="pi pi-chart-bar nav-icon"/>
            <span class="tile-title">Lernbriefe anwenden</span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin"
          class="tiles"
          aria-label="Dokumentationskacheln - Logbuch"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Logbuch', url: docLogbuch })"
        >
          <div class="tile-head">
            <i class="pi pi-book nav-icon"/>
            <span class="tile-title"><strong>Logbuch</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - Tickets"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Tickets', url: docTickets })"
        >
          <div class="tile-head">
            <i class="pi pi-ticket nav-icon"/>
            <span class="tile-title"><strong>Tickets</strong></span>
          </div>
        </button>
      </section>
      <section
          v-if="isAdmin || isTeacher"
          class="tiles"
          aria-label="Dokumentationskacheln - changelog"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Changelog', url: docChangeLog })"
        >
          <div class="tile-head">
            <i class="pi pi-history nav-icon"/>
            <span class="tile-title"><strong>Changelog</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isParent"
          class="tiles"
          aria-label="Dokumentationskacheln - Meldungen"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Meldungen', url: docMeldungenPt })"
        >
          <div class="tile-head">
            <i class="pi pi-users nav-icon"/>
            <span class="tile-title"><strong>Meldungen</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isParent"
          class="tiles"
          aria-label="Dokumentationskacheln - Hinweise"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Hinweise', url: docHinweisePt })"
        >
          <div class="tile-head">
            <i class="pi pi-info-circle nav-icon"/>
            <span class="tile-title"><strong>Hinweise</strong></span>
          </div>
        </button>
      </section>

      <section
          v-if="isParent"
          class="tiles"
          aria-label="Dokumentationskacheln - Fehlzeiten"
      >
        <button
            class="tile"
            @click="openDoc({ title: 'Fehlzeiten', url: docFehlzeitenPt })"
        >
          <div class="tile-head">
            <i class="pi pi-times-circle nav-icon"/>
            <span class="tile-title"><strong>Fehlzeiten</strong></span>
          </div>
        </button>
      </section>
    </div>

    <!-- Fallback bei fehlender/unerwarteter Rolle -->
    <p
        v-if="!isAdmin && !isTeacher && !isParent"
        class="notice mt-12"
        role="status"
    >
      Keine Dokumente gefunden.
    </p>

    <!-- Dialog -->
    <div
        v-if="showDialog"
        class="overlay"
        @click.self="closeDialog"
    >
      <section
          ref="dialogEl"
          class="dialog"
          role="dialog"
          aria-modal="true"
          :aria-labelledby="dialogLabelId"
          tabindex="-1"
      >
        <header class="dialog-header">
          <h2
              :id="dialogLabelId"
              class="h2"
          >
            {{ dialogTitle }}
          </h2>
          <div class="dialog-header-actions inline-flex gap-3">
            <button
                class="btn btn-print"
                type="button"
                :disabled="loading || !dialogHtml"
                style="height: 32px;"
                @click="printDoc"
            >
              Drucken
            </button>
            <button
                class="icon-btn"
                aria-label="Schließen"
                @click="closeDialog"
            >
              ×
            </button>
          </div>
        </header>

        <div
            v-if="loading"
            class="dialog-body"
        >
          <div class="skeleton skeleton-title"/>
          <div class="skeleton skeleton-line"/>
          <div class="skeleton skeleton-line"/>
          <div class="skeleton skeleton-line"/>
        </div>

        <div
            v-else-if="error"
            class="dialog-body"
        >
          <p
              class="notice notice-danger"
              role="alert"
          >
            {{ error }}
          </p>
        </div>

        <div
            v-else
            class="dialog-body doc-content"
            v-html="dialogHtml"
        />

        <footer class="dialog-footer">
          <button
              class="btn"
              @click="closeDialog"
          >
            Schließen
          </button>
        </footer>
      </section>
    </div>
  </main>
</template>

<script setup>
import {ref, nextTick, onBeforeUnmount, computed, onMounted} from 'vue';
import {useAuthStore} from '@/stores/auth';
import {useRoute} from 'vue-router';

// Expliziter Import der Doku-HTMLs (Asset-URL)
import docAngeboteTagesplan from './documentation/angebote_tagesplan.html';
import docAngeboteAutomatik from './documentation/angebote_automatik.html';
import docAngeboteUebersicht from './documentation/angebote_uebersicht.html';
import docAuswertung from './documentation/auswertung.html';
import docAuswertungLernbriefeErzeugen from './documentation/auswertung_lernbriefe_erzeugen.html';
import docAuswertungLernbriefeAnwenden from './documentation/auswertung_lernbriefe_anwenden.html';
import docBenutzer from './documentation/benutzer.html';
import docBenutzerTr from './documentation/benutzer_tr.html';
import docDashboard from './documentation/dashboard.html';
import docDashboardPt from './documentation/dashboard_pt.html';
import docFehlzeitenPt from './documentation/fehlzeiten_pt.html';
import docGruppen from './documentation/gruppen.html';
import docHinweisePt from './documentation/hinweise_pt.html';
import docLogbuch from './documentation/logbuch.html';
import docLoginPasswort from './documentation/login_passwort.html';
import docMeldungenPt from './documentation/meldungen_pt.html';
import docPostausgang from './documentation/postausgang.html';
import docSchuelerHinweise from './documentation/schueler_hinweise.html';
import docSchuelerMeldungen from './documentation/schueler_meldungen.html';
import docSchuelerUebersicht from './documentation/schueler_uebersicht.html';
import docSchuljahre from './documentation/schuljahre.html';
import docTickets from './documentation/tickets.html';
import docChangeLog from './documentation/changelog.html';

const route = useRoute();

const docsById = {
  dashboard: {title: 'Dashboard', url: docDashboard},
  dashboard_pt: {title: 'Dashboard', url: docDashboardPt},
  login_passwort: {title: 'Login und Passwort', url: docLoginPasswort},

  schuljahre: {title: 'Schuljahre', url: docSchuljahre},

  angebote_uebersicht: {title: 'Angebote – Übersicht', url: docAngeboteUebersicht},
  angebote_automatik: {title: 'Angebote – Automatik', url: docAngeboteAutomatik},
  angebote_tagesplan: {title: 'Angebote – Tagesplan', url: docAngeboteTagesplan},

  benutzer: {title: 'Benutzer', url: docBenutzer},
  benutzer_tr: {title: 'Benutzer', url: docBenutzerTr},

  gruppen: {title: 'Gruppen', url: docGruppen},
  postausgang: {title: 'Postausgang', url: docPostausgang},
  auswertung: {title: 'Auswertung', url: docAuswertung},
  logbuch: {title: 'Logbuch', url: docLogbuch},
  tickets: {title: 'Tickets', url: docTickets},
  changelog: {title: 'Changelog', url: docChangeLog},

  schueler_uebersicht: {title: 'Schüler - Übersicht', url: docSchuelerUebersicht},
  schueler_meldungen: {title: 'Schüler - Meldungen', url: docSchuelerMeldungen},
  schueler_hinweise: {title: 'Schüler - Hinweise', url: docSchuelerHinweise},

  meldungen_pt: {title: 'Meldungen', url: docMeldungenPt},
  hinweise_pt: {title: 'Hinweise', url: docHinweisePt},
  fehlzeiten_pt: {title: 'Fehlzeiten', url: docFehlzeitenPt},
};

onMounted(() => {
  const docId = String(route.query?.doc || '').trim();
  if (!docId) return;

  const doc = docsById[docId];
  if (!doc) return;

  openDoc(doc);
});

// Rolle aus Auth-Store bestimmen (analog Notifications.vue)
const auth = useAuthStore();
const roleId = computed(() => auth.user?.roleId ?? auth.user?.role_id ?? null);
const isAdmin = computed(() => roleId.value === 1);
const isTeacher = computed(() => roleId.value === 2);
const isParent = computed(() => roleId.value === 3);

const showDialog = ref(false);
const dialogTitle = ref('');
const dialogHtml = ref('');
const loading = ref(false);
const error = ref('');
const dialogEl = ref(null);
const dialogLabelId = `dialog-title-${Math.random().toString(36).slice(2, 8)}`;

function onKeydown(e) {
  if (e.key === 'Escape') {
    closeDialog();
  }
}

function printDoc() {
  if (!dialogHtml.value) {
    return;
  }

  const title = dialogTitle.value || 'Dokumentation';

  const styles = `
    <style>
      :root {
        --text: #111827;
        --muted: #6B7280;
        --border: #E5E7EB;
      }
      html, body {
        height: auto;
        min-height: 100%;
      }
      body {
        margin: 16px;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        font-size: 14px;
        line-height: 1.5;
        color: var(--text);
      }
      .doc-page {
        max-width: 1120px;
        margin: 0 auto;
      }
      .doc-page-header {
        border-bottom: 1px solid var(--border);
        padding-bottom: 8px;
        margin-bottom: 16px;
      }
      .doc-page-header-title {
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 4px;
      }
      .doc-page-toc ol {
        list-style: none;
      }
      .doc-page-toc {
        border-bottom: 1px solid #000;
      }
      .doc-page-toc ol li a {
        text-decoration: none;
        color: black;
       }
      .doc-page-header-subtitle {
        font-size: 13px;
        color: var(--muted);
        margin: 0;
      }
      img {
        max-width: 100%;
        height: auto;
      }
      .image-block {
        margin: 10px 0 16px;
        text-align: center;
      }
      .image-caption {
        font-size: 12px;
        color: var(--muted);
        margin-top: 4px;
      }
      @media print {
        body {
          margin: 10mm;
        }
        .avoid-break {
          break-inside: avoid;
          page-break-inside: avoid;
        }
      }
    </style>
  `;

  const html = `
    <!doctype html>
    <html lang="de">
      <head>
        <meta charset="utf-8">
        <title>${title}</title>
        <base href="${location.origin}/">
        ${styles}
      </head>
      <body>
        ${dialogHtml.value}
        <scr` + `ipt>
          window.onload = function () {
            window.focus();
            window.print();
          };
        </scr` + `ipt>
      </body>
    </html>
  `;

  const blob = new Blob([html], {type: 'text/html'});
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank', 'noopener');

  if (!win) {
    URL.revokeObjectURL(url);
    return;
  }
}

async function openDoc(doc) {
  dialogTitle.value = doc.title;
  showDialog.value = true;
  loading.value = true;
  error.value = '';
  dialogHtml.value = '';

  window.addEventListener('keydown', onKeydown);
  await nextTick();
  dialogEl.value?.focus();

  try {
    const res = await fetch(doc.url, {cache: 'no-store'});
    if (!res.ok) {
      throw new Error(`Laden fehlgeschlagen (${res.status})`);
    }
    const html = await res.text();
    dialogHtml.value = html;
  } catch (e) {
    error.value = e?.message || 'Unbekannter Fehler beim Laden des Dokuments.';
  } finally {
    loading.value = false;
  }
}

function closeDialog() {
  showDialog.value = false;
  dialogHtml.value = '';
  error.value = '';
  loading.value = false;
  window.removeEventListener('keydown', onKeydown);
}

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown);
});
</script>

<style scoped>
/* Page/Layout */
.page {
  padding: 16px;
  background: var(--bg);
  color: var(--text);
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--border);
}

.h1 {
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  margin: 0;
}

.h2 {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  margin: 0;
}

/* Tiles */
.tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.tile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  cursor: pointer;
  text-align: left;
  transition: background 160ms, border-color 160ms, transform 120ms;
}

.tile:hover {
  background: color-mix(in srgb, var(--primary) 8%, transparent);
}

.tile:active {
  transform: translateY(1px);
}

.tile-title {
  font-size: 14px;
}

.tile-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tile-icon {
  width: 24px;
  height: 24px;
  color: var(--primary);
  flex: 0 0 auto;
}

.tile-sub {
  font-size: 12px;
  color: var(--muted);
}

/* Dialog/Overlay */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .35);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 50;
}

.dialog {
  width: 100%;
  max-width: 1220px;
  max-height: calc(100vh - 64px);
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .16);
  display: flex;
  flex-direction: column;
  outline: none;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
}

.dialog-body {
  padding: 14px;
  overflow: auto;
}

.dialog-footer {
  padding: 12px 14px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* Icon button */
.icon-btn {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text);
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  line-height: 28px;
  text-align: center;
  font-size: 18px;
}

.icon-btn:hover {
  background: color-mix(in srgb, var(--primary) 8%, transparent);
}

/* Buttons */
.btn {
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  cursor: pointer;
}

.btn:hover {
  border-color: var(--border-strong);
  background: color-mix(in srgb, var(--primary) 6%, transparent);
}

.btn-print {
  font-size: 13px;

}

/* Skeletons */
.skeleton {
  border-radius: 6px;
  background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.06) 25%,
      rgba(0, 0, 0, 0.12) 37%,
      rgba(0, 0, 0, 0.06) 63%
  );
  background-size: 400% 100%;
  animation: shimmer 1.2s ease-in-out infinite;
}

.skeleton-title {
  height: 18px;
  width: 60%;
  margin-bottom: 12px;
}

.skeleton-line {
  height: 12px;
  width: 100%;
  margin-bottom: 8px;
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

/* Doc content defaults */
.doc-content :deep(h1),
.doc-content :deep(h2),
.doc-content :deep(h3) {
  margin-top: 0;
}

.doc-content :deep(p) {
  margin: 0 0 10px 0;
  line-height: 1.5;
}

/* Detail-Layout für eingebettete Doku-Seiten */
.doc-content :deep(.doc-page) {
  max-width: 1120px;
  margin: 0 auto;
  padding: 16px 4px 24px;
  background: var(--surface);
  font-size: 14px;
  line-height: 19px;
}

.doc-content :deep(.doc-page-header) {
  border-bottom: 1px solid var(--border);
  padding-bottom: 8px;
  margin-bottom: 16px;
}

.doc-content :deep(.doc-page-header-title) {
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  margin: 0 0 4px;
}

.doc-content :deep(.doc-page-header-subtitle) {
  font-size: 13px;
  line-height: 1.4;
  color: var(--muted);
  margin: 0;
}

.doc-content :deep(h2) {
  font-size: 18px;
  line-height: 1.35;
  font-weight: 600;
  margin: 24px 0 8px;
  color: blueviolet;
}

.doc-content :deep(h3) {
  font-size: 15px;
  line-height: 1.4;
  font-weight: 600;
  margin: 25px 0 8px;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-style: dashed;
}

.doc-content :deep(h4) {
  font-size: 13px;
  margin: 14px 0 4px;
}

doc-content :deep(ul),
.doc-content :deep(ol) {
  margin: 0 0 8px 20px;
  padding: 0;
}

.doc-content :deep(li) {
  margin: 0 0 4px;
}

.doc-content :deep(hr) {
  border: 0;
  border-top: 1px solid var(--border);
  margin: 16px 0;
}

.doc-content :deep(code) {
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 13px;
  background: #F3F4F6;
  padding: 1px 4px;
  border-radius: 3px;
}

.doc-content :deep(pre code) {
  display: block;
  padding: 8px 10px;
  overflow-x: auto;
}

.doc-content :deep(a) {
  color: var(--primary);
  text-decoration: underline;
}

.doc-content :deep(a:hover) {
  color: var(--primary-600);
}

.doc-content :deep(.muted) {
  color: var(--muted);
}

.doc-content :deep(.notice) {
  border-radius: 6px;
  border: 1px solid var(--border);
  padding: 10px 12px;
  margin: 12px 0;
  font-size: 14px;
  background: #F9FAFB;
}

.doc-content :deep(.notice-strong) {
  border-color: var(--border-strong);
  background: #EEF2FF;
}

.doc-content :deep(.image-block) {
  margin: 10px 0 16px;
  text-align: center;
}

.doc-content :deep(.image-block img) {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  border: 1px solid var(--border);
}

.doc-content :deep(.image-caption) {
  font-size: 12px;
  color: var(--muted);
  margin-top: 4px;
}

.doc-content :deep(.definition-list) {
  margin: 0 0 8px;
  padding: 0;
}

.doc-content :deep(.definition-list dt) {
  font-weight: 600;
  margin-top: 6px;
}

.doc-content :deep(.definition-list dd) {
  margin: 0 0 4px 0;
}

.doc-content :deep(.scenario) {
  border-radius: 6px;
  border: 1px solid var(--border);
  padding: 10px 12px;
  margin: 12px 0;
  background: #F9FAFB;
}

.doc-content :deep(.scenario-title) {
  font-weight: 600;
  margin-bottom: 4px;
}

.doc-content :deep(.badge) {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 1.3;
  background: #EEF2FF;
  color: #312E81;
}

.doc-content :deep(.table-like) {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0 12px;
  font-size: 13px;
}

.doc-content :deep(.table-like th),
.doc-content :deep(.table-like td) {
  border-bottom: 1px solid var(--border);
  padding: 6px 8px;
  vertical-align: top;
}

.doc-content :deep(.table-like th) {
  text-align: left;
  font-weight: 500;
  font-size: 12px;
  color: var(--muted);
  background: #F9FAFB;
}

.doc-content :deep(.footer) {
  margin-top: 24px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
  font-size: 12px;
  color: var(--muted);
}

.section-container {
  gap: 12px;
  display: grid;
}

/* Zentrales Styling für Inhaltsverzeichnisse in Dokus */
.doc-content :deep(.doc-page-toc) {
  border-bottom-style: double;
  border-bottom-color: #ccc;
  padding-bottom: 20px;
}

.doc-content :deep(.doc-page-toc ol) {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.doc-content :deep(.doc-page-toc ol li.submenu-header > ol) {
  margin-left: 15px;
}

.doc-content :deep(.doc-page-toc ol li.submenu-header > a) {
  font-weight: 500;
}

.doc-content :deep(.doc-page-toc ol li) {
  margin-top: 10px;
}

.doc-content :deep(.doc-page-toc ol ol li) {
  margin: 2px 0;
}

.doc-content :deep(.doc-page-toc ol li a) {
  text-decoration: none;
  color: black;
  font-size: 15px;
  font-weight: 500;
  padding-top: 3px;
}

.doc-content :deep(.doc-page-toc ol li a:hover) {
  color: blueviolet;
}

.doc-content :deep(.doc-page-toc ol ol li a) {
  font-size: 13px;
  padding-left: 20px;
  font-weight: 400;
  color: #444;
}

.mt-12 {
  margin-top: 12px;
}

.notice {
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 10px 12px;
  background: var(--surface);
}

.notice-danger {
  background: color-mix(in srgb, var(--danger) 10%, transparent);
  border-color: color-mix(in srgb, var(--danger) 35%, var(--border));
}
</style>